import { render, staticRenderFns } from "./BusinessClosedModal.vue?vue&type=template&id=3dd5c27f"
import script from "./BusinessClosedModal.vue?vue&type=script&lang=js"
export * from "./BusinessClosedModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports